import styled from 'styled-components';

export const OurStrengthStyled = styled.div`
  width: 100%;
  padding: 30px 20px;
`;

export const ContainerStyled = styled.div`
  max-width: 1450px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  gap: 50px;
  flex-direction: column;

  .main-text {
    font-size: 20px;
    line-height: 32px;

    text-align: center;
    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      font-size: 24px;
      line-height: 29.05px;
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: 32px;
      line-height: 50px;
    }
  }

  .our-strength-data {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 30px;
    padding: 0 30px;

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      flex-direction: row;
    }
  }
`;

export const OurStrengthCountsStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex-direction: column;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    justify-content: flex-start;
    align-items: flex-start;
  }

  .main-counts {
    display: flex;
    flex-direction: column;
    gap: 18px;
    justify-content: center;
    align-items: center;

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      justify-content: flex-start;
      align-items: flex-start;
    }

    & .counts {
      font-size: 30px;
      line-height: 36.31px;

      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        font-size: 32px;
        line-height: 38.73px;
      }
      @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
        font-size: 40px;
        line-height: 48.41px;
      }
    }
  }
`;
